import React, { useState } from 'react';
import { Download, FileText } from 'lucide-react';
import { exportToCSV, exportToPDF } from '../utils/exportUtils';

const btnStyle = {
    display: 'flex', alignItems: 'center', gap: '5px', background: '#f1f5f9', color: '#334155',
    border: 'none', padding: '6px 12px', borderRadius: '6px', fontSize: '11px', fontWeight: '700', cursor: 'pointer'
};

// `rows` exports exactly what is passed. For server-paged tables pass `getRows` instead: an async
// function returning EVERY row matching the current filters (not just the visible page).
const ExportButtons = ({ rows, getRows, columns, filename, title }) => {
    const [exportingPdf, setExportingPdf] = useState(false);
    const [exportingCsv, setExportingCsv] = useState(false);
    const [exportError, setExportError] = useState('');

    const resolveRows = async () => (getRows ? getRows() : rows);

    const handleCsv = async () => {
        setExportingCsv(true);
        setExportError('');
        try {
            exportToCSV(await resolveRows(), columns, filename);
        } catch (err) {
            console.error('Failed to export CSV:', err);
            setExportError('Export failed');
        } finally {
            setExportingCsv(false);
        }
    };

    const handlePdf = async () => {
        setExportingPdf(true);
        setExportError('');
        try {
            await exportToPDF(await resolveRows(), columns, filename, title);
        } catch (err) {
            console.error('Failed to export PDF:', err);
            setExportError('Export failed');
        } finally {
            setExportingPdf(false);
        }
    };

    return (
        <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={handleCsv} disabled={exportingCsv} style={{ ...btnStyle, opacity: exportingCsv ? 0.6 : 1 }}>
                <Download size={12} /> {exportingCsv ? 'Preparing...' : 'Export CSV'}
            </button>
            <button onClick={handlePdf} disabled={exportingPdf} style={{ ...btnStyle, opacity: exportingPdf ? 0.6 : 1 }}>
                <FileText size={12} /> {exportingPdf ? 'Generating...' : 'Export PDF'}
            </button>
            {exportError && <span role="alert" style={{ fontSize: '11px', color: '#b91c1c', alignSelf: 'center' }}>{exportError}</span>}
        </div>
    );
};

export default ExportButtons;